// Client layer (TS-2.5.03). The audit query's own filter form - actor/action/entity/time-range,
// per AuditQuery. Free-text fields throughout: there is no reference-list vocabulary for "action"
// or "entity type" codes (they are the audit log's own coded strings, not one of D-004's
// vocabularies), so a datalist here would have to fabricate a closed set this API never publishes.
import { useState } from "react";
import type { FormEvent } from "react";
import { FormField } from "../../components/FormField";
import { formFieldControlProps } from "../../components/formFieldControlProps";
import type { AuditQueryParams } from "../../api/audit";
import { strings } from "../../strings";

export interface AuditFilterBarProps {
  readonly onApply: (filters: Omit<AuditQueryParams, "pageNumber" | "pageSize">) => void;
}

const F = strings.audit.filters;

const EMPTY = { actorPrincipalId: "", action: "", entityType: "", entityKey: "", fromInclusiveUtc: "", toExclusiveUtc: "" };

export function AuditFilterBar({ onApply }: AuditFilterBarProps) {
  const [form, setForm] = useState(EMPTY);

  function apply(event: FormEvent) {
    event.preventDefault();
    onApply({
      actorPrincipalId: form.actorPrincipalId.trim() || undefined,
      action: form.action.trim() || undefined,
      entityType: form.entityType.trim() || undefined,
      entityKey: form.entityKey.trim() || undefined,
      fromInclusiveUtc: form.fromInclusiveUtc || undefined,
      toExclusiveUtc: form.toExclusiveUtc || undefined,
    });
  }

  function clear() {
    setForm(EMPTY);
    onApply({});
  }

  return (
    <form className="eg-audit-filters" onSubmit={apply}>
      <FormField id="eg-audit-actor" label={F.actor}>
        <input
          type="text"
          value={form.actorPrincipalId}
          onChange={(event) => setForm((current) => ({ ...current, actorPrincipalId: event.target.value }))}
          {...formFieldControlProps("eg-audit-actor")}
        />
      </FormField>
      <FormField id="eg-audit-action" label={F.action}>
        <input
          type="text"
          value={form.action}
          onChange={(event) => setForm((current) => ({ ...current, action: event.target.value }))}
          {...formFieldControlProps("eg-audit-action")}
        />
      </FormField>
      <FormField id="eg-audit-entity-type" label={F.entityType}>
        <input
          type="text"
          value={form.entityType}
          onChange={(event) => setForm((current) => ({ ...current, entityType: event.target.value }))}
          {...formFieldControlProps("eg-audit-entity-type")}
        />
      </FormField>
      <FormField id="eg-audit-entity-key" label={F.entityKey}>
        <input
          type="text"
          value={form.entityKey}
          onChange={(event) => setForm((current) => ({ ...current, entityKey: event.target.value }))}
          {...formFieldControlProps("eg-audit-entity-key")}
        />
      </FormField>
      <FormField id="eg-audit-from" label={F.from}>
        <input
          type="date"
          value={form.fromInclusiveUtc}
          onChange={(event) => setForm((current) => ({ ...current, fromInclusiveUtc: event.target.value }))}
          {...formFieldControlProps("eg-audit-from")}
        />
      </FormField>
      <FormField id="eg-audit-to" label={F.to}>
        <input
          type="date"
          value={form.toExclusiveUtc}
          onChange={(event) => setForm((current) => ({ ...current, toExclusiveUtc: event.target.value }))}
          {...formFieldControlProps("eg-audit-to")}
        />
      </FormField>
      <button type="submit">{F.apply}</button>
      <button type="button" onClick={clear}>
        {F.clear}
      </button>
    </form>
  );
}
